import GenericController from './../generic.controller';

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.currentAreaActiveTab = 0;
        this.areasStateTexts = [this.gettext('armed'), this.gettext('disarmed'), this.gettext('stay_armed'), this.gettext('Zone alarm'),
            this.gettext('arm in progress'), this.gettext('stay arm in progress'), this.gettext('Area'), this.gettext('Zone 24 hours alarm'),
            this.gettext('Can not arm'), this.gettext('Can not stay arm'), this.gettext('Area is not ready to arm'),
            this.gettext('Fire alarm'), this.gettext('Panic alarm'), this.gettext('EN alarm'), this.gettext('Duress alarm'),
            this.gettext('Code attempts alarm'), this.gettext('Medical alarm'), this.gettext('Emergency alarm')];
        this.loading = true;
        this.currentExitDelay = null;
        this.getAllTroubles();

        super.getAreasConfigList().then((r) => {
            this.areas = r;
            if (this.areas.length > 0) {
                this.currentIndexForMobile = this.areas[0].id;
            }

            this.getPanicAlarmState();
        })
            .finally(r => this.loading = false);

        this.$element.on('$destroy', () => {
            this.closeAllModals();
        });

        this.armedAreaEvent = this.$rootScope.$on('armed', (e, eventObj) => {
            this._armEventHandler(eventObj);
        });

        this.stayArmedAreaEvent = this.$rootScope.$on('stay_armed', (e, eventObj) => {
            this._armEventHandler(eventObj, true)
        });

        this.panicEvent = this.$rootScope.$on('panic', (e, eventObj) => {
            if(eventObj.value) {
                this.playPanicAudio();
            }
            this.refreshAreas();
        });

        this.socketEventReference = this.$rootScope.$on('socketEvent', (e, event) => {
            this.refreshAreas();
        });

        this.panelArmedByUserEvent = this.$rootScope.$on('panelArmedByUser', (e, event) => {
            this.refreshAreas();
        });

        this.panelStayArmedByUserEvent = this.$rootScope.$on('panelStayArmedByUser', (e, event) => {
            this.refreshAreas();
        });

        this.$element.on('$destroy', () => {
            this.armedAreaEvent();
            this.stayArmedAreaEvent();
            this.panicEvent();
            this.socketEventReference();
            this.panelArmedByUserEvent();
            this.panelStayArmedByUserEvent();
        });
    }

    _armEventHandler(eventObj, stay = false) {
        let isArmed = eventObj.value;

        if (isArmed) {
            let exitDelayKey = 'exit_delay';

            if(stay) {
                exitDelayKey = 'stay_exit_delay';
            }
            this.currentExitDelay = _.find(this.areas, {id: eventObj.indexes[0]})[exitDelayKey];
            this.armInProgressEventHandler();
        } else {
            this.playAreaIsDisarmed();
            this.refreshAreas();
            this.CountdownService.stopArmProcessCountdown();
        }
    }

    setEditableArea() {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    let currentMappedAreaObject = angular.copy(this.currentEditableArea);
                    currentMappedAreaObject = _.pick(currentMappedAreaObject, ['id', 'name', 'exit_delay', 'stay_exit_delay']);
                    this.ModalDialogService.isModalClosed = true;
                    this.$scope.currentPromise = this._PanelsService.changePanelArea(this.panelId, currentMappedAreaObject, userCode).then(resp => {
                        let area = resp.data;
                        this.popMessage(area.name + ' ' + this.updateOKText);
                        this.UserCodeService.saveUserCode(userCode);
                        _.merge(this.areas, area);
                    }).finally(this.ModalDialogService.isModalClosed = false)
                }
            }).catch(() => {
        });
    }

    exitTimeChange(timeReferenceKey) {
        if (this.currentEditableArea[timeReferenceKey] > 255) {
            this.currentEditableArea[timeReferenceKey] = 255
        } else if (this.currentEditableArea[timeReferenceKey] < 0) {
            this.currentEditableArea[timeReferenceKey] = 0;
        }
    }

    showEditAreaModal(area) {

        this.currentEditableArea = angular.copy(area);
        this.showModal('editAreaModal')
    }

    armInProgressExitDelayCounter() {

        this.getAreas().then(() => {
            if (this.CountdownService.getExitDelayCounter() == undefined && this.CountdownService.stopped == undefined &&
                this.CountdownService.busy == false) {
                this.CountdownService._setExitDelayCounter(this.currentExitDelay);
                this.CountdownService._startCountdown(this.getAreas.bind(this));
                this.voiceable = true;
            }
        });
    }

    armInProgressEventHandler() {
        this.armInProgressExitDelayCounter();
    }

    refreshAreas(timeout = 1500) {
        this.$timeout(this.getAreas.bind(this), timeout);
    }

    getAreas() {
        return super.getAreasConfigList().then((r) => {
            this.areas = _.merge(this.areas, r);

            let currentArea = _.find(this.areas, (area) => {
                return area.id === this.currentIndexForMobile;
            });

            if (currentArea) {
                let currentState = currentArea.state;

                if (this.isOnArmState(currentState)) {
                    this._onVoiceEvent(this.playAreaIsArmed.bind(this))
                } else if (this.isOnStayState(currentState)) {
                    this._onVoiceEvent(this.playAreaIsStayArmed.bind(this))
                }
            }

            this.getPanicAlarmState();
            this.getAllTroubles();
        })
    }

    getAllTroubles() {
        this.getTroubles();
        this.getZonesTroubles();
        this.getOutputsTroubles();
        if (!this.isSerenityPanel()) {
            this.getKeypadsTroubles();
            this.getUsersTroubles();
        }
    }

    getTroubles() {
        this.loadingGeneralTroubles = true;
        super.getTroubles()
            .then((r) => {
                this.currentTroubles = r.data;
                super.adjustTroublesNames();
                this.loadingGeneralTroubles = false;
            })
            .catch(() => {
                this.loadingGeneralTroubles = false;
            });
    }

    getZonesTroubles() {

        super.getZonesConfigList()
            .then((r) => {
                this.zonesTroubles = r;
                this.getZonesLoading = false;
            })
            .catch(() => {
                this.getZonesLoading = false
            });
    }

    getOutputsTroubles() {

        super.getOutputsConfigList()
            .then((r) => {
                this.outputsTroubles = r;
                this.getOutputsLoading = false;
            })
            .catch(() => {
                this.getOutputsLoading = false
            });
    }

    getKeypadsTroubles() {

        super.getKeypadsConfigList()
            .then((r) => {
                this.keypadsTroubles = r;
                this.getKeypadsLoading = false;
            })
            .catch(() => {
                this.getKeypadsLoading = false
            });
    }

    getUsersTroubles() {

        super.getUsers()
            .then((r) => {
                this.usersTroubles = r;
                this.getUsersLoading = false;
            })
            .catch(() => {
                this.getUsersLoading = false
            });
    }

    openTroubles() {
        this.$scope.$emit('openTroubles');
    }

    closeAllModals() {
        this.closeModal('forceArmModal');
        this.closeModal('forceStayArmModal');
        this.closeModal('serenityAreaNotReadyModal');
    }

    playAreaIsArmed() {
        this._playAreaAudio();
        setTimeout(this._playArmAudio, 400);
    }

    playAreaIsDisarmed() {
        this._playAreaAudio();
        setTimeout(this._playDisarmAudio, 400);
    }

    playAreaIsStayArmed() {
        this._playStayArmAudio();
        setTimeout(this._playAreaAudio, 400);
        setTimeout(this._playArmAudio, 800);
    }

    _playArmAudio() {
        let audio = document.getElementById('armAudio');
        audio.play();
    }

    _playDisarmAudio() {
        let audio = document.getElementById('disarmAudio');
        audio.play();
    }

    _playStayArmAudio() {
        let audio = document.getElementById('stayAudio');
        audio.play();
    }

    playPanicAudio() {
        let audio = document.getElementById('panicAudio');
        audio.play();
    }

    _playAreaAudio() {
        let audio = document.getElementById('areaAudio');
        audio.play();
    }

    _onVoiceEvent(voiceFunc) {

        if (this.voiceable) {
            voiceFunc();
        }

        this.voiceable = false;
    }

    getAreaById(areaId) {
        return _.find(this.areas, {id: areaId})
    }

    _onGetAreas(func, exitDelay = null) {

        this.$scope.currentPromise = func.then((r) => {

            if (exitDelay && this.CountdownService.getExitDelayCounter() == undefined) {
                this.CountdownService._setExitDelayCounter(exitDelay);
                this.CountdownService._startCountdown(this.getAreas.bind(this));
            }
            let currentAreaObject = this.getAreaById(r.data.id);
            let areaIdToPosition = this.areas.indexOf(currentAreaObject);
            this.areas[areaIdToPosition] = _.merge(currentAreaObject, r.data);
            this.voiceable = true;
        })
            .finally(() => {
                this.loading = false;
            });
    }

    isOnDisarmState(areaState) {
        return areaState == 'disarmed';
    }

    isOnArmState(areaState) {
        return areaState == 'armed';
    }

    isOnStayState(areaState) {
        return areaState == 'stay_armed';
    }

    isReadyToArm(areaId) {
        return this.getAreaById(areaId).ready_to_arm;
    }

    isReadyToStayArm(areaId) {
        return this.getAreaById(areaId).ready_to_stay;
    }

    isZoneAlarm(areaId) {
        return this.getAreaById(areaId).zone_alarm;
    }

    isZone24HoursAlarm(areaId) {
        return this.getAreaById(areaId).zone24H_alarm;
    }

    isFireAlarm(areaId) {
        return this.getAreaById(areaId).fire_alarm;
    }

    isPanicAlarm(areaId) {
        return this.getAreaById(areaId).panic_alarm;
    }

    isEnAlarm(areaId) {
        return this.getAreaById(areaId).en_alarm;
    }

    isDuressAlarm(areaId) {
        return this.getAreaById(areaId).duress_alarm;
    }

    isCodeAttemptsAlarm(areaId) {
        return this.getAreaById(areaId).code_attempts_alarm;
    }

    isMedicalAlarm(areaId) {
        return this.getAreaById(areaId).medical_alarm;
    }

    isEmergencyAlarm(areaId) {
        return this.getAreaById(areaId).emergency_alarm;
    }

    isAreaAlarm(area) {
        return _.includes(this.getAreaState(area), 'alarm');
    }

    getAreaState(area) {
        let areaId = area.id;
        let areaState = area.state;
        let notReadyToArm = !this.isReadyToArm(areaId);
        let areaMsg = [];

        if (this.isZoneAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Zone alarm')));
        }  if (this.isZone24HoursAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Zone 24 hours alarm')));
        }  if (this.isFireAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Fire alarm')));
        }  if (this.isPanicAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Panic alarm')));
        }  if (this.isEnAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('EN alarm')));
        }  if (this.isDuressAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Duress alarm')));
        }  if (this.isCodeAttemptsAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Code attempts alarm')));
        }  if (this.isMedicalAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Medical alarm')));
        }  if (this.isEmergencyAlarm(areaId)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Emergency alarm')));
        }  if (notReadyToArm && this.isOnDisarmState(areaState)) {
            areaMsg.push(this.$filter('humanize')(this.gettext('Area is not ready to arm')));
        }

        if(_.isEmpty(areaMsg)) {
             return this.$filter('humanize')(this.getTranslatableText((areaState)));
        }else {
             return areaMsg.join(', ').toString();
        }
    }

    disarm(area) {
        this.refreshAreas();
        if (this.isOnDisarmState(area.state)) {
            this._onGetAreas(super.forceDisarm(area.id));
        } else {
            this._onGetAreas(super.disarm(area.id));
        }
        this.CountdownService.stopArmProcessCountdown();
    }

    arm(area) {
        this.refreshAreas();
        if (this.isOnDisarmState(area.state)) {

            if (this.isReadyToArm(area.id)) {

                this._onGetAreas(super.arm(area.id), area.exit_delay);
            } else {
                if (this._isSerenityPanel) {
                    this._showSerenityAreaNotReadyModal('Can not arm');
                } else {
                    this._setForcedArea(area.id, area.state);
                    $('#forceArmModal').modal('show');
                }
            }
        }
    }

    stayArm(area) {
        this.refreshAreas();
        if (this.isOnDisarmState(area.state)) {

            if (this.isReadyToStayArm(area.id)) {

                this._onGetAreas(super.stayArm(area.id), area.stay_exit_delay);
            } else {
                if (this._isSerenityPanel) {
                    this._showSerenityAreaNotReadyModal('Can not stay arm');
                } else {
                    this._setForcedArea(area.id, area.state);
                    $('#forceStayArmModal').modal('show');
                }
            }
        }
    }

    _showSerenityAreaNotReadyModal(action) {
        this.$scope.currentActionForArea = action;
        $('#serenityAreaNotReadyModal').modal('show');
    }

    _setForcedArea(areaId, areaState) {
        this.forceArmAreaId = areaId;
        this.forcedAreaState = areaState;
    }

    forceArm() {

        if (this.isOnDisarmState(this.forcedAreaState)) {
            this._onGetAreas(super.forceArm(this.forceArmAreaId), this.getAreaById(this.forceArmAreaId).exit_delay);
        }
    }

    forceStayArm() {

        if (this.isOnDisarmState(this.forcedAreaState)) {
            this._onGetAreas(super.forceStayArm(this.forceArmAreaId), this.getAreaById(this.forceArmAreaId).stay_exit_delay);
        }
    }

    setPanicAlarm() {

        if (!this.isRemotePanicDisabled() && this.isCurrentPanelPanicEnabled()) {
            this.$scope.currentPromise = super.setPanicAlarm().then(r => {
                this.isPanic = r.data.panic_alarm;
            });
        }
    }

    getPanicAlarmState() {
        super.getPanicAlarmState()
            .then((r) => {
                this.isPanic = r.data.panic_alarm;
            });
    }

    replaceWithUnderscore(state) {
        return _.snakeCase(state);
    }

    setIndexForMobile(index) {
        this.currentIndexForMobile = index;
    }

    isTabSet(index) {
        return this.currentIndexForMobile === index;
    }

    isRemotePanicDisabled() {
        return this.isVersion('1.2.3.42');
    }

    isCurrentPanelPanicEnabled() {
        return this.isPanicEnabled;
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/areas.component/controller.js
 **/